import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noSpaces',
})
export class NoSpacesPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    return (phoneNumber || '').replace(/ /g, '');
  }
}
